export default "__VITE_ASSET__e593640d__"